import { Input } from '@/components/ui-kit/input';
import { Search } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface CommonContractHeaderProps {
  title: string;
  subtitle: string;
  search?: string;
  setSearch?: (value: string) => void;
  searchPlaceholder?: string;
  /** Optional content rendered immediately next to the search input. Used
      on mobile to host the Refresh button alongside Search; desktop tucks
      it elsewhere by passing it wrapped in `md:hidden`. */
  action?: ReactNode;
}

const CommonContractHeader = ({
  title,
  subtitle,
  search,
  setSearch,
  searchPlaceholder,
  action,
}: CommonContractHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col  gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-xl md:text-3xl font-bold text-[hsl(var(--fg))] font-nunito">
          {t(title)}
        </h1>
        <p className="mt-1.5 md:mt-3">{t(subtitle)}</p>
      </div>
      <div className="flex w-full max-w-lg items-center gap-2">
        <div className="relative flex-1">
          {/* Search */}
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-globe-grey" />
          <Input
            placeholder={t(searchPlaceholder ?? 'ORGCONTRACTS_SEARCHPLACEHOLDER')}
            value={search ?? ''}
            onChange={(event) => setSearch?.(event.target.value)}
            className="pl-9 shadow-none"
          />
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    </div>
  );
};

export default CommonContractHeader;
